import UserAvatar from "../../../../components/UserAvatar";
import { formatIDR } from "../../../../utils/helpers/formatIDR";
import { canOpenCatalogProduct } from "../../productCatalog";
import TablerIcon from "../TablerIcon";
import "./style.css";

const formatStock = (value) => Number(value).toLocaleString("id-ID", { maximumFractionDigits: 4 });

const ProductListSkeleton = () => (
  <div className="pos-product-list" role="status" aria-label="Memuat produk">
    {Array.from({ length: 6 }, (_, index) => (
      <div className="pos-product-list-row pos-product-list-skeleton placeholder-glow" key={index} aria-hidden="true">
        <span className="pos-product-list-image placeholder" />
        <span className="pos-product-list-copy">
          <span className="placeholder col-8" />
          <span className="placeholder placeholder-xs col-5" />
        </span>
        <span className="pos-product-list-trailing">
          <span className="placeholder pos-product-list-price-placeholder" />
          <span className="placeholder pos-product-list-action-placeholder" />
        </span>
      </div>
    ))}
  </div>
);

const ProductListView = ({ products = [], loading = false, search = "", onSelect }) => {
  if (loading) return <ProductListSkeleton />;

  if (!products.length) {
    return (
      <div className="pos-product-list-empty" role="status">
        <TablerIcon name="search" size={28} />
        <strong>{search ? "Produk tidak ditemukan" : "Belum ada produk pada kategori ini"}</strong>
        <span>
          {search ? "Coba kata kunci lain atau pilih semua kategori." : "Pilih kategori lain untuk melihat produk."}
        </span>
      </div>
    );
  }

  return (
    <ul className="pos-product-list" aria-label="Daftar produk">
      {products.map((product) => {
        const variants = product?.is_product_group ? product.variants || [] : [];
        const hasVariants = variants.length > 1;
        const stockProduct = variants.length === 1 ? variants[0] : product;
        const remainingStock = stockProduct?.remaining_stock;
        const isOutOfStock = product?.is_product_group ? !product.can_sell : Number(remainingStock || 0) <= 0;
        const canOpen = !isOutOfStock || canOpenCatalogProduct(product);
        const isUnlimited = stockProduct?.is_unlimited || !Number.isFinite(Number(remainingStock));
        const isLowStock =
          !hasVariants &&
          !isOutOfStock &&
          !isUnlimited &&
          Number(remainingStock) <= Math.max(2, Number(stockProduct?.min_stock || 0));
        const isMadeToOrder = stockProduct?.inventory_mode === "made_to_order";
        const availableVariants = variants.filter(
          (variant) => variant.can_sell !== false && variant.remaining_stock > 0,
        ).length;
        const category = product?.category_label || product?.category;
        const hasPriceRange = hasVariants && Number(product.maximum_price) > Number(product.minimum_price);
        const actionLabel = isOutOfStock
          ? canOpen
            ? "Lihat penyebab"
            : "Habis"
          : hasVariants
            ? "Pilih varian"
            : "Tambah";
        const stockLabel = isOutOfStock
          ? isMadeToOrder
            ? "Bahan tidak cukup"
            : "Tidak tersedia"
          : hasVariants
            ? `${availableVariants} dari ${variants.length} varian tersedia`
            : isUnlimited
              ? "Tersedia"
              : `${isMadeToOrder ? "Bisa dibuat" : "Stok"} ${formatStock(remainingStock)} ${stockProduct?.unit || "pcs"}`;

        return (
          <li key={`${product.is_product_group ? "group" : "product"}-${product.id}`}>
            <button
              type="button"
              className={`pos-product-list-row ${isOutOfStock ? "is-out-of-stock" : ""} ${isLowStock ? "is-low-stock" : ""}`}
              disabled={!canOpen}
              aria-label={`${actionLabel}: ${product.name}, ${stockLabel}`}
              onClick={(event) =>
                onSelect(product, event.currentTarget.querySelector(".pos-product-list-image") || event.currentTarget)
              }>
              <UserAvatar
                fullName={product.name}
                imageUrl={product.image_path || product.image || stockProduct.image_path || stockProduct.image}
                size="md"
                className="pos-product-list-image"
                justPhotoView
              />
              <span className="pos-product-list-copy">
                <strong className="pos-product-list-name">{product.name}</strong>
                {category || hasVariants ? (
                  <span className="pos-product-list-meta">
                    {category ? <span>{category}</span> : null}
                    {hasVariants ? <span>{variants.length} varian</span> : null}
                  </span>
                ) : null}
                <span className="pos-product-list-stock">
                  <span className="pos-product-list-status-dot" aria-hidden="true" />
                  {stockLabel}
                </span>
              </span>
              <span className="pos-product-list-trailing">
                <span className="pos-product-list-price">
                  {hasPriceRange ? <small>Mulai dari</small> : null}
                  <strong>{formatIDR(product.unit_price || 0)}</strong>
                </span>
                <span className="pos-product-list-action" aria-hidden="true">
                  <TablerIcon name={isOutOfStock ? "alert-triangle" : hasVariants ? "plus" : "plus"} size={16} />
                  {/* <span>{actionLabel}</span> */}
                </span>
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};
export default ProductListView;
